import { QUERY_PARAMS } from 'constants/queryNames';

export const getStAffAndOfferFromUrl = (
  urlValue?: string,
  offerQueryParam: string = QUERY_PARAMS.PARTNER_AFF_OFFER_ID,
) => {
  if (!urlValue) {
    return null;
  }

  try {
    const url = new URL(urlValue);
    const affId = url.searchParams.get(QUERY_PARAMS.PARTNER_KEY);
    const offerId = url.searchParams.get(offerQueryParam);

    if (!affId || !offerId) {
      return null;
    }

    return { affId, offerId };
  } catch {
    return null;
  }
};
